<template>
    <div class="common-scroll">
        <div class="common-header">
            <div class="common-header-right">
                <div class="common-header-block">
                    <el-input v-model="userRandomIdAndNickname" placeholder="请输入ID/昵称">
                        <template slot="prepend">ID/昵称</template>
                    </el-input>
                </div>
                <div class="common-header-block">
                    <el-input style="width: 320px" v-model="externalOrderNo" placeholder="请输入外部订单号">
                        <template slot="prepend">外部订单号</template>
                    </el-input>
                </div>
                <div class="common-header-block">
                    <el-input style="width: 320px" v-model="internalOrderNo" placeholder="请输入内部订单号">
                        <template slot="prepend">内部订单号</template>
                    </el-input>
                </div>
                <div class="common-header-block">状态：
                    <el-select class="common-el-select-small" v-model="status">
                        <el-option
                                v-for="item of statusOptions"
                                :key="item.label"
                                :value="item.value"
                                :label="item.label"/>
                    </el-select>
                </div>
                <div class="common-header-block">客户端类型：
                    <el-select class="common-el-select-small" v-model="appType">
                        <el-option
                                v-for="item of appTypeOptions"
                                :key="item.label"
                                :value="item.value"
                                :label="item.label"/>
                    </el-select>
                </div>
                <div class="common-header-block">外部支付渠道：
                    <el-select v-model="channelCodeAndPaymentWay">
                        <el-option
                                v-for="item of payList"
                                :key="item.label"
                                :value="item.value"
                                :label="item.label"/>
                    </el-select>
                </div>
                <div class="common-header-block">内部支付渠道：
                    <el-select v-model="payType">
                        <el-option
                                v-for="item of payTypeOptions"
                                :key="item.label"
                                :value="item.value"
                                :label="item.label"/>
                    </el-select>
                </div>
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            type="datetimerange"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                    <el-button type="success" @click="exportFunc">导出</el-button>
                </div>
            </div>
        </div>
        <div v-if="permissions.osm_all_field">
            <strong class="common-text-item" v-text="`总充值：${centerRecharge.totalOrderPrice} 记分牌`"></strong>
            <strong class="common-text-item" v-text="`总成功笔数：${centerRecharge.totalSuccess}`"></strong>
            <strong class="common-text-item" v-text="`总支付手续费：${centerRecharge.totalFee} 记分牌`"></strong>
            <strong class="common-text-item" v-text="`成功率：${centerRecharge.successRate * 100 }%`"></strong>
        </div>

        <div class="common-table">
            <el-table
                    row-key="internalOrderNo"
                    v-loading="loading"
                    :data="centerRecharge.beanList"
                    height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                type="primary"
                                @click="updateStatus(scope.row)">手工处理
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="回调状态" align="center">
                    <template slot-scope="scope">{{scope.row.callbackStatus | callbackStatusName}}</template>
                </el-table-column>
                <el-table-column label="状态" min-width="120" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.manualHandlingFlag === 1">手工-支付成功</template>
                        <template v-else>
                            {{scope.row.status | statusName}}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="用户ID/渠道ID" width="150" align="center" prop="userRandomId"/>
                <el-table-column label="用户昵称/渠道昵称" width="150" align="center" prop="userNickname"/>
                <el-table-column label="备注/名字" width="80" align="center" prop="remark"/>
                <el-table-column label="所属俱乐部" min-width="150" align="center" prop="clubName"/>
                <el-table-column label="所属联盟" min-width="150" align="center" prop="tribeName"/>
                <el-table-column label="内部订单号" width="300" align="center" prop="internalOrderNo"/>
                <el-table-column label="外部订单号" width="200" align="center" prop="externalOrderNo"/>
                <el-table-column label="充值金额" min-width="120" align="center" prop="amount"/>
                <el-table-column label="手续费" min-width="80" align="center" prop="fee"/>
                <el-table-column label="外部支付渠道" min-width="180" align="center" prop="paymentName"/>
             <!--   <el-table-column label="外部支付渠道" min-width="180" align="center">
                    <template slot-scope="scope">{{scope.row.channelCode |
                        channelCodeAndPaymentWay(scope.row.paymentWay)}}
                    </template>
                </el-table-column>-->
                <el-table-column label="内部渠道" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.payType | payTypeName}}</template>
                </el-table-column>
                <el-table-column label="客户端类型" align="center" width="150">
                    <template slot-scope="scope">{{scope.row.appType | appTypeName}}</template>
                </el-table-column>
                <el-table-column label="创建时间" width="150" align="center" prop="createdTime"/>
                <el-table-column label="支付时间" width="150" align="center" prop="paymentTime"/>
                <el-table-column label="银行卡号" width="180" align="center" prop="bankAccount"/>
                <el-table-column label="银行名称" align="center" prop="bankName"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="centerRecharge.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import {rechargeOrderMixin} from 'mixins'

    export default {
        mixins: [rechargeOrderMixin],
        data() {
            return {
                loading: false,
                appType: '',// 客户端类型
                appTypeOptions: [
                    {label: '全部', value: ''},
                    // {label: 'Android', value: 1},
                    // {label: 'iOS', value: 2},
                    {label: 'Web', value: 3},
                    {label: 'Wap', value: 4},
                ],
                externalOrderNo: '',// 外部订单号
                internalOrderNo: '',// 内部订单号
                status: '',// 状态
                date: null,
                payType: '',// 内部渠道
                payTypeOptions: [
                    {label: '全部', value: ''},
                    {label: 'CMS俱乐部充值', value: '0'},
                    {label: 'CMS代充渠道充值', value: '1'},
                    {label: '玩家商城充值', value: '2'},
                ],
                channelCode: '',// 外部支付渠道
                paymentWay: '',// 支付方式
                channelCodeAndPaymentWay: '',
                channelCodeAndPaymentWayOptions: [
                    {
                        label: '全部',
                        value: ''
                    },
                    {
                        label: 'Upay - 银行卡',
                        value: 'Upay,4',
                    },
                    {
                        label: '易付 - 银联快捷支付',
                        value: 'Onepay,3',
                    },
                    {
                        label: '国内支付宝 - 支付宝',
                        value: 'Alipay-China,1',
                    },
                    {
                        label: '香港支付宝 - 支付宝',
                        value: 'Alipay-HK,1',
                    },
                    {
                        label: '新加坡支付宝 - 支付宝',
                        value: 'Alipay-Singapore,1',
                    },
                    {
                        label: '大通 - 支付宝',
                        value: 'DaTongPay,1',
                    },
                    {
                        label: '影响力支付 - 支付宝',
                        value: 'EffectPay,1',
                    },
                    {
                        label: '影响力支付 - 微信',
                        value: 'EffectPay,5',
                    },
                    {
                        label: '最强支付 - 支付宝',
                        value: 'Stronger,1',
                    },
                    {
                        label: '天天pay - 支付宝',
                        value: 'TianPay,1',
                    },
                    {
                        label: '天机 - 支付宝',
                        value: 'TianJi,1',
                    },
                    {
                        label: '天机 - 微信',
                        value: 'TianJi,5',
                    },
                    {
                        label: '通合 - 支付宝',
                        value: 'TongHe,1',
                    },
                    {
                        label: '通合 - 微信',
                        value: 'TongHe,5',
                    },
                    {
                        label: '科成支付 - 支付宝',
                        value: 'KeCheng,1',
                    },
                    {
                        label: '汇达支付 - 支付宝',
                        value: 'HuiDa,1',
                    },
                    {
                        label: '汇达支付 - 微信',
                        value: 'HuiDa,5',
                    },
                    {
                        label: '星辰 - 支付宝',
                        value: 'XinChen,1',
                    },
                    {
                        label: '星辰 - 微信',
                        value: 'XinChen,5',
                    }
                ],
                currentPage: 1,
                userRandomIdAndNickname: '',
                centerRecharge: {// 中央收付充值
                    beanList: [],
                    total: 0,
                    totalOrderPrice: 0,// 总充值
                    totalSuccess: 0,// 总成功笔数
                    totalFee: 0,// 总支付手续费
                    successRate: 0,// 成功率
                }
            }
        },
        computed: {
            ...mapState('login', ['permissions']),
            ...mapState('mallPayChannel', ['payList']),
        },
        watch: {
            channelCodeAndPaymentWay(newVal) {
                let arr = newVal.split(',');
                this.channelCode = arr[0];
                if (this.channelCodeAndPaymentWay.length > 1) {
                    this.paymentWay = arr[1]
                } else {
                    this.paymentWay = ''
                }
            }
        },
        created() {
            this.getPayList()
        },
        filters: {
            payTypeName(type) {
                if (type === 0) {
                    return 'CMS俱乐部充值'
                } else if (type === 1) {
                    return 'CMS代充渠道充值'
                } else if (type === 2) {
                    return '玩家商城充值'
                }
            }
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('mallPayChannel', ['getPayList']),
            ...mapActions('rechargeOrder', ['centerRechargeList', 'rechargeOrdersManualHandling']),
            parameterCalibration() {
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return false
                }
                return true
            },
            getList(page = 1) {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                this.currentPage = page;
                this.centerRechargeList({
                    appType: this.appType,
                    channelCode: this.channelCode,
                    paymentWay: this.paymentWay,
                    status: this.status,
                    startTime: this.date[0],
                    endTime: this.date[1],
                    page,
                    internalOrderNo: this.internalOrderNo,
                    externalOrderNo: this.externalOrderNo,
                    payType: this.payType,
                    userRandomIdAndNickname: this.userRandomIdAndNickname
                }).then(res => {
                    this.centerRecharge = res;
                    this.loading = false;
                })
            },
            // 手工处理发放金豆
            updateStatus(row) {
                this.$confirm('确定发放金豆给玩家？', '提示', {
                    type: 'info'
                }).then(() => {
                    this.rechargeOrdersManualHandling({
                        orderNo: row.externalOrderNo,
                        type: 1
                    }).then(() => {
                        this.$message.success('请求成功');
                        this.getList(this.currentPage)
                    })
                }).catch(() => {
                });
            },
            exportFunc() {
                if (!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action: '/rechargeOrders/center/export',
                    info: [
                        {name: 'channelCode', value: this.channelCode},
                        {name: 'paymentWay', value: this.paymentWay},
                        {name: 'appType', value: this.appType},
                        {name: 'status', value: this.status},
                        {name: 'startTime', value: this.date[0]},
                        {name: 'endTime', value: this.date[1]},
                        {name: 'internalOrderNo', value: this.internalOrderNo},
                        {name: 'externalOrderNo', value: this.externalOrderNo},
                        {name: 'payType', value: this.payType},
                        {name: 'userRandomIdAndNickname', value: this.userRandomIdAndNickname},
                    ]
                });
            }
        }
    }
</script>